<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="400px" persistent>
    <v-card>
      <v-card-title class="title">
        Map the Influencer on behalf
      </v-card-title>
      <v-card-text class="body-2">
        <p v-if="postData.length">
          Mapping influencer for <strong>{{postData.length}}</strong> selected posts.
        </p>
        <v-radio-group
          v-model="platform"
          row
        >
          <v-radio
            label="Instagram"
            value="instagram"
          ></v-radio>
          <v-radio
            label="TikTok"
            value="tiktok"
          ></v-radio>
          <v-radio
            label="Youtube"
            value="youtube"
          ></v-radio>
          <v-radio
            label="LinkedIn"
            value="linkedin"
          ></v-radio>
        </v-radio-group>
        <v-text-field
          prefix="@"
          label="Handle"
          v-model="handle"
          block
          :disabled="isValidating"
          outlined
        ></v-text-field>
        <table v-if="postData.length" class="post-table">
          <thead>
            <tr>
              <th class="text-left">Influencer</th>
              <th class="text-left">Campaign</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in postData" :key="item._id || index">
              <td class="text-xs-justify pa-1">
                <a
                  :href="'https://www.tiktok.com/@' + item.author.tiktokHandle"
                  target="_blank"
                  v-if="item.author && item.author.tiktokHandle"
                ><img src="/static/img/tiktok-32.png" width="20px" /> @{{item.author.tiktokHandle}}</a>
                <a
                  :href="'https://youtube.com/' + item.author.youtubeHandle"
                  target="_blank"
                  v-else-if="item.author && item.author.youtubeHandle"
                ><v-icon>mdi-youtube</v-icon> @{{item.author.youtubeHandle}}</a>
                <a
                  :href="'https://www.linkedin.com/in/' + item.author.linkedinHandle"
                  target="_blank"
                  v-else-if="item.author && item.author.linkedinHandle"
                ><v-icon>mdi-linkedin</v-icon> @{{item.author.linkedinHandle}}</a>
                <a
                  :href="'https://instagram.com/' + item.author.instagramHandle"
                  target="_blank"
                  v-else-if="item.author && item.author.instagramHandle"
                ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{item.author.instagramHandle}}</a>
                <span v-else>-</span>
              </td>
              <td class="text-xs-left">{{ item.campaignName || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </v-card-text>
      <v-card-actions>        
        <v-btn color="red" text @click.native="$emit('input')">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="saveMappedInfluencer()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import config from '@/config';
import postAPIs from './postApi';
// import influencerAPIs from '../Influencer/influencerAPIs';

export default {
  props: {
    value: Boolean,
    posts: Array
  },
  data () {
    return {
      platform: 'instagram',
      postData: [],
      isValidating: false,
      handle: ''
    }
  },
  methods: {
    saveMappedInfluencer() {
      if (!this.handle) {
        this.$swal({
          type: 'warning',
          title: 'Please input handle'
        })
        return
      }

      this.isValidating = true;
      let selectedPosts = Array.isArray(this.postData) ? this.postData : []
      Promise.all(selectedPosts.map(post => postAPIs.mapInfluencerToPost(post._id, {handle: this.handle, platform: this.platform})))
        .then(() => {
          this.isValidating = false;
          this.$emit('successInfluencerMap')
          this.close()
        })
        .catch(error => {
          this.isValidating = false;
          this.$swal({
            type: 'error',
            text: error
          })
          console.log(error)
        })
    },
    close() {
      this.handle = '';
      this.$emit('input');
    }
  },
  watch: {
    posts(newPostList) {
      if (Array.isArray(newPostList) && newPostList.length > 0) {
        this.postData = newPostList
      } else {
        this.postData = []
      }
    }
  }
}
</script>

<style scoped>
.post-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 12px;
}

.post-table th,
.post-table td {
  padding: 6px 8px;
  border-bottom: 1px solid #eee;
}
</style>



// WEBPACK FOOTER //
// MapInfluencerMultipleModal.vue?f811f5e0